import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col col-sm-12" }
const _hoisted_2 = { class: "card h-100" }
const _hoisted_3 = { class: "card-body d-flex flex-column justify-content-center align-items-center" }
const _hoisted_4 = { class: "card-title h3 mb-0 text-nowrap" }
const _hoisted_5 = { class: "card-footer last-updated-text text-muted text-center small" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "card h-100" }
const _hoisted_8 = { class: "card-body d-flex flex-row justify-content-center align-items-center" }
const _hoisted_9 = { class: "card-title h3 mb-0 ms-4 text-nowrap" }
const _hoisted_10 = { class: "card-footer last-updated-text text-muted text-center small" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "card h-100" }
const _hoisted_13 = { class: "card-body d-flex flex-column justify-content-center align-items-center" }
const _hoisted_14 = { class: "card-title h3 mb-0 text-nowrap" }
const _hoisted_15 = { class: "card-footer last-updated-text text-muted text-center small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_transfer_gtr_points = _resolveComponent("transfer-gtr-points")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "card-header text-truncate" }, [
          _createElementVNode("i", { class: "fas fa-coins fa-fw text-red me-1" }),
          _createElementVNode("span", null, "Puntos Totales")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h6", _hoisted_4, "G$ " + _toDisplayString(_ctx.earned), 1)
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.earnedDate), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "card-header text-truncate" }, [
          _createElementVNode("h5", null, [
            _createElementVNode("i", { class: "fas fa-wallet fa-fw me-1" }),
            _createElementVNode("span", null, "Puntos Disponibles")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h6", _hoisted_9, "G$ " + _toDisplayString(_ctx.total), 1),
          _createElementVNode("div", {
            class: "btn btn-sm btn-outline-secondary ms-3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openTransferModal()))
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "fas fa-share fa-fw" }, null, -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.totalDate), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "card-header text-truncate" }, [
          _createElementVNode("i", { class: "fas fa-plane-departure fa-fw me-1" }),
          _createElementVNode("span", null, "Puntos Utilizados")
        ], -1)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h6", _hoisted_14, "G$ " + _toDisplayString(_ctx.expended), 1)
        ]),
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.expendedDate), 1)
      ])
    ]),
    _createVNode(_component_transfer_gtr_points, {
      total: _ctx.summary.total
    }, null, 8, ["total"])
  ], 64))
}